import { PHASES, TEAMS } from "../data/constants";
import { TODAY } from "./schedule";

const inCurrentMonth = (dstr) => {
  if (!dstr) return false;
  const d = new Date(dstr);
  return d.getFullYear() === TODAY.getFullYear() && d.getMonth() === TODAY.getMonth();
};


export const fmtMoney = (n) =>
  "$" + Number(n || 0).toLocaleString("en-US");

export const fmtMoneyShort = (n) => {
  const v = Number(n || 0);
  if (v >= 1_000_000) return "$" + (v / 1_000_000).toFixed(2) + "M";
  if (v >= 1000) return "$" + (v / 1000).toFixed(0) + "K";
  return "$" + v;
};

// Compute collection stats for a list of projects
export function financeStats(projects) {
  let totalContract = 0, collected = 0, invoiced = 0, pending = 0;
  projects.forEach((p) => {
    totalContract += p.contractAmount || 0;
    (p.payments || []).forEach((pay) => {
      if (pay.status === "paid") collected += pay.amount;
      else if (pay.status === "invoiced") invoiced += pay.amount;
      else if (pay.status === "pending_invoice") pending += pay.amount;
    });
  });
  const receivable = invoiced + pending; // billed or ready-to-bill but not yet paid
  return { totalContract, collected, invoiced, pending, receivable };
}

export function phaseDistribution(projects) {
  return PHASES.map((ph, idx) => ({
    key: ph.key,
    en: ph.en,
    zh: ph.zh,
    color: ph.color,
    count: projects.filter((p) => p.phaseIndex === idx).length,
  }));
}

export function teamDistribution(projects) {
  return TEAMS.map((tm) => {
    const list = projects.filter((p) => p.team === tm.id);
    const avgProgress =
      list.length === 0 ? 0 : Math.round((list.reduce((s, p) => s + (p.phaseIndex + 1) / 7, 0) / list.length) * 100);
    return { id: tm.id, name: tm.name, zh: tm.zh, count: list.length, avgProgress };
  });
}

export const subCompleteness = (c, zh = true) => {
  const items = [
    [c.contact, zh ? "联系人" : "Contact"],
    [c.phone, zh ? "电话" : "Phone"],
    [c.email, "Email"],
    [c.license, zh ? "执照号" : "License"],
    [c.taxId, zh ? "税号" : "Tax ID"],
    [c.address, zh ? "邮寄地址" : "Address"],
    [c.w9OnFile || c.w9FileId, "W-9"],
    [c.workersCompNo, zh ? "工伤保险单号" : "WC No."],
    [c.workersCompExp, zh ? "保险到期日" : "WC Exp."],
  ];
  const missing = items.filter(([v]) => !v).map(([, l]) => l);
  const pct = Math.round(((items.length - missing.length) / items.length) * 100);
  return { pct, missing };
};

export const projectProgress = (p) => (p.phaseIndex >= 7 ? 100 : Math.round(((p.phaseIndex + 1) / 7) * 100));

export const projectCollected = (p) =>
  (p?.payments || []).filter((x) => x.status === "paid").reduce((s, x) => s + (x.amount || 0), 0);

// Per-salesperson aggregation: signed amount, collected, collection rate,
// plus current-month figures for target tracking.
export function salesLeaderboard(projects) {
  const map = {};
  projects.forEach((p) => {
    const name = p.sales || "—";
    if (!map[name]) map[name] = { name, signed: 0, collected: 0, count: 0, monthSigned: 0, monthCollected: 0 };
    const contract = p.contractAmount || 0;
    const paid = projectCollected(p);
    map[name].signed += contract;
    map[name].collected += paid;
    map[name].count += 1;
    if (inCurrentMonth(p.signedDate)) {
      map[name].monthSigned += contract;
      map[name].monthCollected += paid;
    }
  });
  return Object.values(map)
    .map((r) => ({ ...r, rate: r.signed ? Math.round((r.collected / r.signed) * 100) : 0 }))
    .filter((r) => r.name !== "—")
    .sort((a, b) => b.signed - a.signed);
}

